require('./brokerAllIndexesView.scss');

const PropTypes = require('prop-types');

// @vendors
const React = require('react');
const { connect } = require('react-redux');
const moment = require('moment');
const { withRouter } = require('react-router-dom');

// @commons
const { EmptyState } = require('commonsComponents/emptyState');
const { OKCover } = require('commonsComponents/OKCover');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKSectionBox } = require('commonsComponents/OKSectionBox');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { OKTable } = require('commonsComponents/OKTable');
const { OKTableRow } = require('commonsComponents/OKTableRow');
const { OKTableCell } = require('commonsComponents/OKTableCell');
const StockExchangeIndexVariation = require('components/broker/commons/stockExchange/stockExchangeIndexVariation');

// @components
const { LoadingSection } = require('commonsComponents/loadingSection');

// @helpers
const { formatText, FormattedText, getFinalTitle } = require('core/i18n').i18n;
const { formatAmount } = require('utilities/currencyHelper');
const DateHelper = require('utilities/dateHelper');

// @actions
const BrokerAllIndexesActions = require('actions/brokerAllIndexes');

// @constants
const { DATE_FORMAT_ES, BROKER_INDEXES_FIRST_INDEX_POSITION, MYPROFILE_BROKER_EXPLORE_URL} = require('constants/index');
const { es:{ DATE_FORMAT_WITH_DASHES } } = require('commonsConstants/dateFormatTypes');

class BrokerAllIndexesView extends React.Component {
    constructor(props) {
        super(props);

        this.buildTableHeader = this.buildTableHeader.bind(this);
        this.buildTableRows = this.buildTableRows.bind(this);
        this.buildTable = this.buildTable.bind(this);
        this.buildContent = this.buildContent.bind(this);
        this.handleSearchClick = this.handleSearchClick.bind(this);
        this.breadcrumb = [
            {
                text: formatText('breadcrumb-brokerInvestments'),
                url: '/myprofile/broker'
            },
            {
                text: formatText('breadcrumb-brokerMarkets'),
                url: '/myprofile/broker/markets'
            },
            {
                text: formatText('broker-allIndexesTitle'),
                url: ''
            }
        ];
    }

    componentDidMount() {
        this.props.onFetchingIndexes();
    }

    handleSearchClick() {
        this.props.history.push(MYPROFILE_BROKER_EXPLORE_URL);
    }

    buildContent() {
        const { immBrokerAllIndexes } = this.props;
        let content;

        if (immBrokerAllIndexes.get('isFetching')) {
            content = <LoadingSection />;
        } else if (immBrokerAllIndexes.get('errors')) {
            const error = formatText('broker-allIndexesError');
            content = <EmptyState primaryText={error} iconType="nointernet-wealth"/>;
        } else if (immBrokerAllIndexes.get('results').isEmpty()) {
            const noResults = formatText('broker-allIndexesNoResults');
            content = <EmptyState primaryText={noResults} iconType="search-wealth"/>;
        } else {
            content = this.buildTable();
        }

        return content;
    }

    buildTable() {
        return (
            <OKTable className="broker-all-indexes-view__table">
                {this.buildTableHeader()}
                <tbody>
                    {this.buildTableRows()}
                </tbody>
            </OKTable>
        );
    }

    buildTableHeader() {
        return (
            <thead>
                <OKTableRow asHeader={true} className="broker-all-indexes-view__table-header">
                    <OKTableCell asHeader={true} className="broker-all-indexes-view__table-header-cell--indexes-name">
                        <FormattedText value="broker-allIndexesNameLabel" />
                    </OKTableCell>
                    <OKTableCell asHeader={true} className="broker-all-indexes-view__table-header-cell--indexes-last-price broker-all-indexes-view__table-cell--right">
                        <FormattedText value="broker-allIndexesLastPriceLabel" />
                    </OKTableCell>
                    <OKTableCell asHeader={true} className="broker-all-indexes-view__table-header-cell--indexes-date-time broker-all-indexes-view__table-cell--left">
                        <FormattedText value="broker-allIndexesDateTimeLabel" />
                    </OKTableCell>
                    <OKTableCell asHeader={true} className="broker-all-indexes-view__table-header-cell--indexes-minimum broker-all-indexes-view__table-cell--right">
                        <FormattedText value="broker-allIndexesMinimumLabel" />
                    </OKTableCell>
                    <OKTableCell asHeader={true} className="broker-all-indexes-view__table-header-cell--indexes-maximum broker-all-indexes-view__table-cell--right">
                        <FormattedText value="broker-allIndexesMaximumLabel" />
                    </OKTableCell>
                    <OKTableCell asHeader={true} className="broker-all-indexes-view__table-header-cell--indexes-variation broker-all-indexes-view__table-cell--right">
                        <FormattedText value="broker-allIndexesDailyVariationLabel" />
                    </OKTableCell>
                </OKTableRow>
            </thead>
        );
    }

    buildTableRows() {
        const { immBrokerAllIndexes } = this.props;
        const immRows = immBrokerAllIndexes.get('results');

        const immRowsFinal = immRows.delete(BROKER_INDEXES_FIRST_INDEX_POSITION);

        return immRowsFinal.map((immRow, index) => {
            const formatPrice = `${formatAmount(immRow.get('last'))}`;
            const formatNetChangePrice = formatAmount(immRow.get('netChangePrice'));
            const formatNetChangePercentage = formatAmount(immRow.get('netChangePercentage'));

            const tradeDate = DateHelper.buildFormattedDate(
                moment(immRow.get('tradeDate'), DATE_FORMAT_WITH_DASHES),
                DATE_FORMAT_ES
            );

            let indexTime;
            if (tradeDate === 'Invalid Date') {
                indexTime = '-';
            } else {
                indexTime = `${tradeDate} - ${immRow.get('tradeTime')}`;
            }

            return (
                <OKTableRow key={index}>
                    <OKTableCell className="broker-all-indexes-view__table-cell--bold">
                        {immRow.get('instrument')}
                    </OKTableCell>
                    <OKTableCell className="broker-all-indexes-view__table-cell--right">
                        {formatPrice}
                    </OKTableCell>
                    <OKTableCell className="broker-all-indexes-view__table-cell--date-time">
                        {indexTime}
                    </OKTableCell>
                    <OKTableCell className="broker-all-indexes-view__table-cell--right">
                        {formatAmount(immRow.get('low'))}
                    </OKTableCell>
                    <OKTableCell className="broker-all-indexes-view__table-cell--right">
                        {formatAmount(immRow.get('high'))}
                    </OKTableCell>
                    <OKTableCell className="broker-all-indexes-view__table-cell--right">
                        <StockExchangeIndexVariation
                            arrowCustomClassName="broker-all-indexes-view__table-cell--variation-arrow"
                            variationPts={formatNetChangePrice}
                            variationPerc={formatNetChangePercentage}
                        />
                    </OKTableCell>
                </OKTableRow>
            );
        });
    }

    render() {
        return (
            <article className="broker-all-indexes-view">
                <OKCover size="medium" section="broker">
                    <OKHeaderSubPage
                        breadcrumbConfig={this.breadcrumb}
                        finalTitle={getFinalTitle('broker-allIndexesTitle')}
                    >
                        <OKButton
                            inverse={true}
                            modifier="ghost"
                            onClick={this.handleSearchClick}
                        >
                            <FormattedText value="broker-goToAdvancedSearch" />
                        </OKButton>
                    </OKHeaderSubPage>
                </OKCover>
                <section className="broker-all-indexes-view__body">
                    <OKSectionBox>
                        {this.buildContent()}
                    </OKSectionBox>
                </section>
            </article>
        );
    }
}

BrokerAllIndexesView.propTypes = {
    history: PropTypes.object.isRequired,
    immBrokerAllIndexes: PropTypes.object.isRequired,
    onFetchingIndexes: PropTypes.func.isRequired,
};

module.exports.constructor = BrokerAllIndexesView;
module.exports.BrokerAllIndexesView = connect(
    (state) => ({ immBrokerAllIndexes: state.brokerAllIndexes }),
    {
        onFetchingIndexes: BrokerAllIndexesActions.fetchIndexes,
    }
)(withRouter(BrokerAllIndexesView));
